import PropTypes from 'prop-types';
import React from 'react';

class AgentDetail extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      save: false,
    };
  }
  componentDidMount() {
  }


  render() {
    const { agent } = this.props;

    return (
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <h4>{agent.first_name} {agent.last_name}</h4>
          </div>
          <div className="col-md-4">
          </div>
        </div>
        <div className="row">
          <div className="col-md-8">
          </div>
        </div>
      </div>
    );
  }
}


AgentDetail.propTypes = {
  agent: PropTypes.object.isRequired,
};

export default AgentDetail;



// WEBPACK FOOTER //
// src/routes/agency/components/AgentDetail.js